import * as PropTypes from 'prop-types'
import classNames from 'classnames'
import { Motion, spring } from 'react-motion'

import stackedSliderStyles from './StackedSlider.css'
import { MOTION_PRESETS } from '/react/constants/motionPresets'

import {
  CustomCursorNextPrevious,
  ToFullscreenAnimation
} from '/react/library/'

import { StackedSliderIndicator } from './StackedSliderIndicator'
import { StackedSliderCaption } from './StackedSliderCaption'

export class StackedSliderFullscreen extends React.PureComponent {
  static propTypes = {
    activeSlide: PropTypes.node.isRequired,
    activeSlideIndex: PropTypes.number.isRequired,
    animationFrameTarget: PropTypes.any.isRequired,
    getSlidePositionInStack: PropTypes.func.isRequired,
    goToNextSlide: PropTypes.func.isRequired,
    goToPreviousSlide: PropTypes.func.isRequired,
    originalTotalSlides: PropTypes.number.isRequired,
    previousActiveSlideIndex: PropTypes.number.isRequired,
    slides: PropTypes.node.isRequired,
    toggleFullscreen: PropTypes.func.isRequired
  }

  goToPreviousSlide = () => {
    this.props.goToPreviousSlide()
  }

  goToNextSlide = () => {
    this.props.goToNextSlide()
  }

  setKeyHandlers = () => {
    this.setState({ areKeyHandlersEnabled: true })
  }

  handleCursorClick = (event) => {
    event.isMousePositionLeft
      ? this.goToPreviousSlide()
      : this.goToNextSlide()
  }

  render () {
    const {
      animationFrameTarget,
      activeSlide,
      activeSlideIndex,
      getSlidePositionInStack,
      originalTotalSlides,
      previousActiveSlideIndex,
      slides,
      toggleFullscreen
    } = this.props

    const slidesProps = {
      activeSlideIndex,
      getSlidePositionInStack,
      previousActiveSlideIndex,
      slides
    }

    const stackedSliderIndicatorProps = {
      activeSlideIndex,
      originalTotalSlides
    }

    const activeSlideCaption = activeSlide.props.caption || null

    return (
      <ToFullscreenAnimation
        animationFrameTarget={animationFrameTarget}
        closeFullscreenCallback={toggleFullscreen}
        onAnimationEnd={this.setKeyHandlers}
        content={
          <Slides {...slidesProps} />
        }
        uiElements={
          <React.Fragment>
            <NextPreviousCursor onClick={this.handleCursorClick} />
            {activeSlideCaption && <StackedSliderCaption caption={activeSlideCaption} />}
            <StackedSliderIndicator {...stackedSliderIndicatorProps} />
          </React.Fragment>
        }
        zoomContent={
          <div className={stackedSliderStyles.fullscreenSlide}>
            {slides[activeSlideIndex]}
          </div>
        }
      />
    )
  }
}

const Slides = (props) => {
  const springConfig = MOTION_PRESETS.FAST

  const layoutConfig = {
    0: {
      opacity: 0,
      positionDelta: 0,
      zIndex: 0
    },
    2: {
      opacity: 0,
      positionDelta: -10,
      zIndex: 1
    },
    3: {
      opacity: 1,
      positionDelta: 0,
      zIndex: 3
    },
    4: {
      opacity: 0,
      positionDelta: 10,
      zIndex: 1
    }
  }

  const getMotionStyles = (positionInStack) => {
    if (positionInStack < 2 || positionInStack > 4) {
      return layoutConfig[0]
    }

    return layoutConfig[positionInStack]
  }

  const BackgroundSlide = () => (
    <div className={stackedSliderStyles.fullscreenSlide}>
      {props.slides[props.previousActiveSlideIndex]}
    </div>
  )

  return (
    <div className={stackedSliderStyles.fullscreenSlides}>
      <BackgroundSlide />
      {props.slides.map((slide, slideIndex) => {
        const positionInStack = props.getSlidePositionInStack(slideIndex)
        const motionStyles = getMotionStyles(positionInStack)
        const shouldAnimate = positionInStack === 3

        return (
          <Motion
            defaultStyle={{
              position: motionStyles.positionDelta,
              opacity: motionStyles.opacity,
              zIndex: motionStyles.zIndex
            }}
            style={{
              position: shouldAnimate ? spring(motionStyles.positionDelta, springConfig) : motionStyles.positionDelta,
              opacity: shouldAnimate ? spring(motionStyles.opacity, springConfig) : motionStyles.opacity,
              zIndex: motionStyles.zIndex
            }}
            key={slideIndex}
          >
            {(interpolatedStyle) => (
              <div
                className={stackedSliderStyles.fullscreenSlide}
                style={{
                  opacity: interpolatedStyle.opacity,
                  transform: `translate3d(${interpolatedStyle.position}%, 0, 0)`,
                  zIndex: interpolatedStyle.zIndex
                }}
              >
                {slide}
              </div>
            )}
          </Motion>
        )
      })}
    </div>
  )
}

const NextPreviousCursor = (props) => (
  <div className={classNames(
    stackedSliderStyles.fullScreenCustomCursorContainer
  )}>
    <CustomCursorNextPrevious onClick={props.onClick} />
  </div>
)
